export default __webpack_public_path__ + "static/media/utilities-not-selected_skyblue.81ff59e8.svg";